import { render } from "./BookRefund.vue?vue&type=template&id=eb1a78be"
import script from "./BookRefund.vue?vue&type=script&lang=js"
export * from "./BookRefund.vue?vue&type=script&lang=js"
script.render = render

export default script